module.exports = __webpack_public_path__ + "static/media/img-exhibition-map-en-US.0fcfc422.png";